// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdatePlanButton_wrapper__nhWHF","loader":"UpdatePlanButton_loader__l5k5-","spin":"UpdatePlanButton_spin__URFk8"};